// src/components/plaid/plaidNav.js
// Pooled inbox SP6 — where the Plaid surfaces send the client, and the one
// signal that the client's links changed on this page.

// Profile's Linked accounts panel. `/profile` is also Plaid's fourth OAuth
// return address (R204's three + /profile, spec § OAuth return handling).
export const PROFILE_PATH = "/profile";
export const LINKED_ANCHOR = "linked";
export const LINKED_ACCOUNTS_PATH = `${PROFILE_PATH}#${LINKED_ANCHOR}`;
// "See the figures": the Questions page at its Debts item (QuestionItem's
// heading id).
export const SEE_FIGURES_PATH = "/questionnaire#qp-q5_debts-h";

// A link, an unlink or Plaid switched off changes the list another panel on
// the same page shows (Settings › Consents and Linked accounts share
// /profile): the changer announces it, the list re-reads.
const LINKS_CHANGED = "astra:plaid-links-changed";
export const announceLinksChanged = () =>
  window.dispatchEvent(new Event(LINKS_CHANGED));
export const onLinksChanged = (listener) => {
  window.addEventListener(LINKS_CHANGED, listener);
  return () => window.removeEventListener(LINKS_CHANGED, listener);
};
